const PlaylistInput = ({ value, onChange, placeholder, extraStyle }) => {
    return (
        <input
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            style={{
                width: "90%",
                padding: "10px",
                marginHorizontal: "2vh",
                marginBottom: "1vh",
                borderRadius: "5px",
                border: "none",
                backgroundColor: "white",
                color: "black",
                ...extraStyle,
            }}
        />
    );
};

export default PlaylistInput;
